import React, { useState, useEffect } from "react";
import { Container, InputField } from "@common";
import DataTableReact from "@common/datatable/DataTableReact.jsx";
import apiService from "services/apiService";
import { Dots } from "../../assets/svg.js";
import { Menu, MenuItem } from "@mui/material";
import CustomModal from "@common/CustomModal/CustomModal.js";
import { FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";

import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";

import { Formik, Form } from "formik";
import * as Yup from "yup";
function Cluster() {
  const [clusters, setClusters] = useState([]);
  const [editableCluster, setEditableCluster] = useState(null);
  const [openRowId, setOpenRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteClusterId, setDeleteClusterId] = useState("");
  const [regions, setRegions] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setOpenRowId(rowId);
  };
  const handleCloseTableModal = () => {
    setAnchorEl(null);
    setOpenRowId(null);
  };

  function handleDeleteCluster({ id, name, regionId }) {
    apiService
      .delete(`cluster/${id}`, { name, region_id: regionId })
      .then((res) => {
        toast.success(res.message);
        fetchClusters();
        setIsModalOpen(false);
        setDeleteClusterId("");
      })
      .catch((err) => {
        toast.error(err.response.data.message);

        console.log("Error Deleting Cluster", err);
      });
  }

  function handleCreateCluster(values) {
    apiService
      .post("cluster", {
        name: values.clusterName,
        region_id: values.default.value,
      })
      .then((res) => {
        toast.success(res.message);
        fetchClusters();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error creating Cluster", err);
      });
  }

  function handleUpdateCluster(values) {
    apiService
      .put(`cluster/${editableCluster?.id}`, {
        name: values.clusterName,
        region_id: values.default.value,
      })
      .then((res) => {
        toast.success(res.message);
        fetchClusters();
        setEditableCluster(null);
        setIsEdit(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error Updating Cluster", err);
      });
  }

  function handleClusterSubmit(values, { resetForm }) {
    if (isEdit) {
      handleUpdateCluster(values);
    } else {
      handleCreateCluster(values);
    }
    setOpenForm(false);
    resetForm();
  }

  const columns = [
    {
      id: "Region Name",
      header: "Region Name",

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.regionName}
          </span>
        );
      },
    },
    {
      id: "Cluster Name",
      header: "Cluster Name",

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.clusterName}
          </span>
        );
      },
    },
  ];
  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon cursor-pointer"
            onClick={(e) => handleClick(e, row?.index)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            boxShadow: "none", // Removing box shadow
          }}
        >
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsEdit(true);
                  setOpenForm(true);
                  setEditableCluster({
                    name: row?.original?.clusterName,
                    id: row?.original?.id,
                    regionId: row?.original?.regionId,
                    regionName: row?.original?.regionName,
                  });
                }}
              >
                Edit
              </p>
              {/* <p
                className="self-center m-1 "
                onClick={() => {
                  setIsModalOpen(true);
                  setDeleteClusterId({
                    id: row?.original?.id,
                    name: row?.original?.clusterName,
                    regionId: row?.original?.regionId,
                  });
                }}
              >
                Delete
              </p> */}
            </div>
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsModalOpen(true);
                  setDeleteClusterId({
                    id: row?.original?.id,
                    name: row?.original?.clusterName,
                    regionId: row?.original?.regionId,
                  });
                }}
              >
                Delete
              </p>
            </div>
          </MenuItem>
        </Menu>
      </>
    );
  };
  const fetchRegions = async () => {
    try {
      const { data } = await apiService.get(`region`);
      const regionData = new Map();
      data.map(({ name, _id }) => {
        regionData.set(_id, { label: name, value: _id });
      });
      return regionData;
    } catch (e) {
      console.log("Error fetching regions:", e);
    }
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchClusters = async () => {
    try {
      const { data } = await apiService.get(
        `cluster?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );
      setTotalRows(data?.total);
      const regionData = await fetchRegions();
      const clusetsData = [];

      data?.data?.map(({ name, _id, region }) => {
        clusetsData.push({
          clusterName: name,
          id: _id,
          regionName: region.name,
          regionId: region._id,
        });
      });

      setClusters([...clusetsData]);
      setRegions(regionData);
    } catch (e) {
      console.log("Error fetching Clusters:", e);
    }
  };

  useEffect(() => {
    fetchClusters(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const initialValues = {
    clusterName: editableCluster?.name ? editableCluster?.name : "",
    regionName: regions,
    default: isEdit ? regions.get(editableCluster?.regionId) : "",
  };
  const validationSchema = Yup.object({
    clusterName: Yup.string().required("Cluster Name is required"),
    default: Yup.object().required("Region is required"),
  });

  console.log("isModalOpen", isModalOpen);
  
  return (

    <>
     <CustomModal
        isOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={"Delete Cluster"}
        bodyText={"Are you want to Delete this Cluster?"}
        buttonText={"Delete"}
        onClick={() => handleDeleteCluster(deleteClusterId)}
      />
    {/* <button onClick={()=>{
      setIsModalOpen(true)
    }}>open</button> */}
    <Container>
      <div className="flex gap-2 mb-4">
        <h1>Clusters</h1>
        <div
          className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full transition-transform transform duration-200 
            hover:shadow-lg hover:scale-105 active:scale-95 cursor-pointer"
          onClick={() => setOpenForm(true)}
        >
          <FaPlus className="text-green-500 text-3xl" />
        </div>
      </div>
     
      {openForm && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={handleClusterSubmit}
        >
          {({ values, errors, touched, setFieldValue, handleChange }) => (
            <ModalBody>
              <Form>
                <div className="">
                  <div>
                    <label>
                      Region Name
                      <span className="text-[#2D9F75]">*</span>
                    </label>

                    <Select
                      options={Array.from(values.regionName.values())}
                      value={values.default} // Use `value` instead of `defaultValue`
                      onChange={(selectedOption) => {
                        setFieldValue("default", selectedOption); // Update the value in Formik
                      }}
                    />
                    {touched.default && errors.default && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.default}
                      </div>
                    )}
                  </div>
                  <div>
                    <InputField
                      isRequiredClass="text-[#2D9F75]"
                      label="Cluster Name"
                      name="clusterName"
                      isRequired={true}
                      height="h-[40px]"
                      value={values.clusterName}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.clusterName && errors.clusterName && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.clusterName}
                      </div>
                    )}
                  </div>
                    <div className="d-flex justify-content-end self-end gap-2 mt-4">
                      <Button color="success" type="submit">
                        {!isEdit ? "Submit" : "Update"}
                      </Button>
                      {/* {isEdit && ( */}
                        <Button
                          color="danger"
                          type="submit"
                          onClick={() => {
                            setIsEdit(false);
                            setOpenForm(false);
                            setEditableCluster(null);
                          }}
                        >
                          Cancel
                        </Button>
                      {/* )} */}
                    </div>
                </div>
              </Form>
            </ModalBody>
          )}
        </Formik>
      </div>
      </div>}

      <DataTableReact
        data={clusters}
        columns={columns}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        renderRowActions={handleRenderRowActions}
        shouldShowActions={true}
      />
    </Container>

    </>

  );
}

export default Cluster;
